/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

// @mui material components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import Alert from "@mui/material/Alert";
import TableContainer from "@mui/material/TableContainer";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import TableHeader from "components/Table/TableHeader";
import MDSelect from "components/MDSelect";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";
import InvoiceReceiptOpen from "./InvoiceReceiptOpen";
import InvoiceReceiptSlip from "./InvoiceReceiptSlip";
import InvoicePrintReceipt from "./InvoicePrintReceipt";

const initAttr = {
  id: "",
  code: "",
  code_receipt: "",
  customer_id: "",
  branch_id: "",
  name: "",
  vat_type: "NO",
  revise: "NO",
  remark: "",
  amount: "",
  total: "",
  vat: "",
  nettotal: "",
  account_id: "",
  status: "edit",
  payment_type: "cash",
  slip: "",
  created_at: "",
  updated_at: "",
  date_receipt: Func.dateNow(),
};

const initInvoice = {
  id: "",
  code: "",
  customer_id: "",
  branch_id: "",
  name: "",
  vat_type: "EX",
  revise: "NO",
  remark: "",
  amount: "",
  total: "",
  vat: "",
  nettotal: "",
  paid: "",
  balance: "",
  status: "edit",
};

const initSlip = {
  filedata: null,
  filename: "",
  filesize: 0,
  filetype: "",
};

const initParent = {
  id: "",
  code: "",
  status: "",
};

const initFind = {
  search: "",
  order_by: "tb.id",
  order_sort: "desc",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const stepperName = {
  edit: {
    name: "แก้ไขข้อมูล",
    color: "warning",
    icon: "border_color",
  },
  purchase: {
    name: "สั่งซื้อ",
    color: "info",
    icon: "task_alt",
  },
  receive: {
    name: "รับบางส่วน",
    color: "info",
    icon: "task_alt",
  },
  success: {
    name: "ได้รับครบ",
    color: "success",
    icon: "task_alt",
  },
  reject: {
    name: "ยกเลิก",
    color: "error",
    icon: "cancel",
  },
};

function InvoiceReceipt() {
  const mod = "invoice_receipt";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [parent, setParent] = useState(initParent);
  const [loading, setLoading] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [modalCash, setModalCash] = useState(false);
  const [modalTransfer, setModalTransfer] = useState(false);
  const [notify, setNotify] = useState(null);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [cboAccount, setCboAccount] = useState([]);
  const [invoice, setInvoice] = useState(initInvoice);
  const [slip, setSlip] = useState(initSlip);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: "tb.code", label: t(`attr.code`), align: "center" },
    { id: "tb.type_id", label: "วิธีการชำระ", align: "left" },
    { id: "tb.date_receipt", label: "วันที่ชำระ", align: "center" },
    { id: "tb.remark", label: "จำนวนชำระ", align: "right" },
    { id: "tb.created_at", label: "พิมพ์", align: "center" },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon="notifications"
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData("POST", `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setRecord(result.data);
        setParent(result.parent);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.vat_type, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalCash(false);
    setModalTransfer(false);

    FetchData("PUT", `/${mod}`, app.token, {
      invoice_id: id,
      date_receipt: attr.date_receipt,
      amount: attr.amount,
      remark: attr.remark,
      payment_type: attr.payment_type,
      filedata: slip.filedata,
      filename: slip.filename,
      filesize: slip.filesize,
      filetype: slip.filetype,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.addcomplete`), "success");
      } else {
        setModalCash(true);
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const upload = (filedata, file) => {
    setSlip({
      filedata: filedata,
      filename: file ? file.name : "",
      filesize: file ? file.size : 0,
      filetype: file ? file.type : "",
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const statusDiaplay = (item) => {
    return (
      <Alert
        icon={<Icon>{stepperName[item.status].icon}</Icon>}
        severity={stepperName[item.status].color}
        sx={{
          fontSize: "14px",
          padding: "0 10px",
          fontWeight: 400,
          borderRadius: 5,
          whiteSpace: "nowrap",
        }}
      >
        {stepperName[item.status].name}
      </Alert>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? "desc" : "asc" });
  };

  const init = () => {
    FetchData("OPTIONS", `/${mod}/init`, app.token, {
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setCboAccount(result.account);
        setInvoice(result.invoice);
        view(find);
      } else {
        Func.exitApp();
      }
    });
  };

  const initCash = () => {
    FetchData("OPTIONS", `/${mod}/init`, app.token, {
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setInvoice(result.invoice);
        setAttr({ ...initAttr, payment_type: "cash", amount: result.invoice.balance });
        setSlip(initSlip);
        setConfirm(false);
        setModalCash(true);
      } else {
        Func.exitApp();
      }
    });
  };

  const initTransfer = () => {
    FetchData("OPTIONS", `/${mod}/init`, app.token, {
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setInvoice(result.invoice);
        setAttr({ ...initAttr, payment_type: "transfer", amount: result.invoice.balance });
        setSlip(initSlip);
        setConfirm(false);
        setModalTransfer(true);
      } else {
        Func.exitApp();
      }
    });
  };

  const paymentDisplay = (input) => {
    if (input === "cash") return "เงินสด";
    if (input === "transfer") return "โอนเงิน";
    return "";
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <MDBox
              noValidate
              component="form"
              role="form"
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, page: 1 });
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={10} lg={8}>
                  <MDInput
                    name="searchform"
                    fullWidth
                    value={find.search}
                    onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">{t("element.search")} :</InputAdornment>
                      ),
                      autoComplete: "off",
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            {parent.status === "invoice" ? (
              <MDBox display="flex" justifyContent="flex-end" gap={1}>
                <MDButton variant="outlined" color="info" onClick={initCash}>
                  <Icon>post_add</Icon> ชำระเงินสด
                </MDButton>
                <MDButton variant="outlined" color="success" onClick={initTransfer}>
                  <Icon>post_add</Icon> โอนเงิน
                </MDButton>
              </MDBox>
            ) : null}
          </Grid>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0 }}>
              <Table aria-label="simple table">
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">
                        <InvoiceReceiptOpen parent={row} />
                      </TableCell>
                      <TableCell align="left">{paymentDisplay(row.payment_type)}</TableCell>
                      <TableCell align="center">{Func.dateDisplay(row.date_receipt)}</TableCell>
                      <TableCell align="right">{Func.numberDisplay(row.amount)}</TableCell>
                      <TableCell align="center">
                        <InvoicePrintReceipt parent={row} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
              <MDButton variant={show ? "contained" : "outlined"} color="dark" onClick={openShow}>
                {t(`element.show_record`, { num: find.perPage })}&nbsp;
                <Icon>keyboard_arrow_down</Icon>
              </MDButton>
              {renderShow}
              <Pagination
                count={pageTotal}
                variant="outlined"
                color="secondary"
                showFirstButton
                showLastButton
                page={pageNo}
                onChange={(e, p) => view({ ...find, page: p })}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderCash = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Table aria-label="summary table">
            <TableBody>
              {invoice.vat_type === "NO" ? null : (
                <TableRow>
                  <TableCell align="right">
                    <MDTypography variant="h5">มูลค่าสินค้า</MDTypography>
                  </TableCell>
                  <TableCell align="right" width="200">
                    <MDTypography variant="h5">{Func.numberDisplay(invoice.total)}</MDTypography>
                  </TableCell>
                </TableRow>
              )}
              {invoice.vat_type === "NO" ? null : (
                <TableRow>
                  <TableCell align="right">
                    <MDTypography variant="h5">Vat 7%</MDTypography>
                  </TableCell>
                  <TableCell align="right">
                    <MDTypography variant="h5">{Func.numberDisplay(invoice.vat)}</MDTypography>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">รวมทั้งสิ้น</MDTypography>
                </TableCell>
                <TableCell align="right" width="200">
                  <MDTypography variant="h5">{Func.numberDisplay(invoice.nettotal)}</MDTypography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">ชำระแล้ว</MDTypography>
                </TableCell>
                <TableCell align="right">
                  <MDTypography variant="h5" className="color-success">
                    {Func.numberDisplay(invoice.paid)}
                  </MDTypography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">ค้างชำระ</MDTypography>
                </TableCell>
                <TableCell align="right">
                  <MDTypography variant="h5" className="color-danger">
                    {Func.numberDisplay(invoice.balance)}
                  </MDTypography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDDatePicker
                onChange={([date]) => {
                  setAttr({ ...attr, date_receipt: Func.dateFormat(date) });
                }}
                value={new Date(attr.date_receipt)}
                input={{
                  label: "วันที่ชำระ",
                  variant: "standard",
                  fullWidth: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="จำนวนการโอน"
                onChange={(e) => setAttr({ ...attr, amount: e.target.value })}
                value={attr.amount}
                type="number"
                variant="standard"
                inputProps={{
                  maxLength: 20,
                  autoComplete: "off",
                  className: "text-right",
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label={t(`attr.remark`)}
                onChange={(e) => setAttr({ ...attr, remark: e.target.value })}
                value={attr.remark}
                variant="standard"
                multiline
                inputProps={{
                  autoComplete: "off",
                  maxLength: 200,
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderTransfer = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Table aria-label="summary table">
            <TableBody>
              {invoice.vat_type === "NO" ? null : (
                <TableRow>
                  <TableCell align="right">
                    <MDTypography variant="h5">มูลค่าสินค้า</MDTypography>
                  </TableCell>
                  <TableCell align="right" width="200">
                    <MDTypography variant="h5">{Func.numberDisplay(invoice.total)}</MDTypography>
                  </TableCell>
                </TableRow>
              )}
              {invoice.vat_type === "NO" ? null : (
                <TableRow>
                  <TableCell align="right">
                    <MDTypography variant="h5">Vat 7%</MDTypography>
                  </TableCell>
                  <TableCell align="right">
                    <MDTypography variant="h5">{Func.numberDisplay(invoice.vat)}</MDTypography>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">รวมทั้งสิ้น</MDTypography>
                </TableCell>
                <TableCell align="right" width="200">
                  <MDTypography variant="h5">{Func.numberDisplay(invoice.nettotal)}</MDTypography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">ชำระแล้ว</MDTypography>
                </TableCell>
                <TableCell align="right">
                  <MDTypography variant="h5" className="color-success">
                    {Func.numberDisplay(invoice.paid)}
                  </MDTypography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">
                  <MDTypography variant="h5">ค้างชำระ</MDTypography>
                </TableCell>
                <TableCell align="right">
                  <MDTypography variant="h5" className="color-danger">
                    {Func.numberDisplay(invoice.balance)}
                  </MDTypography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDDatePicker
                onChange={([date]) => {
                  setAttr({ ...attr, date_receipt: Func.dateFormat(date) });
                }}
                value={new Date(attr.date_receipt)}
                input={{
                  label: "วันที่ชำระ",
                  variant: "standard",
                  fullWidth: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="จำนวนการโอน"
                onChange={(e) => setAttr({ ...attr, amount: e.target.value })}
                value={attr.amount}
                type="number"
                variant="standard"
                inputProps={{
                  maxLength: 20,
                  className: "text-right",
                  autoComplete: "off",
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MDSelect
                label="บัญชีโอนเงิน *"
                labelDefault={t(`element.please_select`)}
                data={cboAccount}
                value={attr.account_id}
                onChange={(e) => setAttr({ ...attr, account_id: e.target.value })}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label={t(`attr.remark`)}
                onChange={(e) => setAttr({ ...attr, remark: e.target.value })}
                value={attr.remark}
                variant="standard"
                multiline
                inputProps={{
                  maxLength: 200,
                  autoComplete: "off",
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <MDTypography variant="h5" mb={2}>
                  สลิปโอนเงิน
                </MDTypography>
                {slip.filedata === null ? (
                  <MDBox
                    component="img"
                    src="/images/nopic.jpg"
                    alt={invoice.code}
                    width="100%"
                    height="100%"
                  />
                ) : (
                  <MDBox
                    component="img"
                    src={slip.filedata}
                    alt={invoice.code}
                    width="100%"
                    height="100%"
                  />
                )}

                <MDBox mr={1} display="flex" justifyContent="center">
                  <InvoiceReceiptSlip uploadData={upload} />
                </MDBox>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderModalCash = () => {
    return (
      <Dialog open={modalCash} maxWidth="md" keepMounted aria-describedby="dialog-add" fullWidth>
        <DialogTitle>
          ชำระเงินสด #{invoice.code}
          <IconButton
            aria-label="close"
            onClick={() => setModalCash(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderCash()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="info" onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderModalTransfer = () => {
    return (
      <Dialog
        open={modalTransfer}
        maxWidth="md"
        keepMounted
        aria-describedby="dialog-add"
        fullWidth
      >
        <DialogTitle>
          โอนเงิน #{invoice.code}
          <IconButton
            aria-label="close"
            onClick={() => setModalTransfer(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderTransfer()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="info" onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderModalCash()}
      {renderModalTransfer()}
      {renderLoading()}
      {notify}
    </div>
  );
}

export default InvoiceReceipt;
